module.exports = __webpack_public_path__ + "img/ge_carescape.e9c1cf1e.png";